<div class="d-lg-block pt-4 pb-3 mb-0">
  <h3 class="subtitle_1 txt-darkGray pb-3">
    {{ 'PROCESSES.ACCOMMODATION.LIST.MOBILE_MAP_TITLE' | translate }}
  </h3>
  <div class="d-flex flex-column mt-3">
    <div class="map-container d-lg-block br-16 h-100 ">
      <div class="map" id="map"></div>
    </div>

  </div>

  <div class="d-block pt-3" *ngIf="!embassyCenter">
    <h3 class="subtitle_1 txt-darkGray pt-2">
      {{ 'PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.SEARCH_ROUTE' | translate }}
    </h3>

    <div class="box w-100">
      <div class="border-bottom w-100 d-flex gap-24">
        <div [ngClass]="{'searchopen': open}" class="position-relative border-primary border lf-font w-100">
          <div class="flex-grow-1 d-flex align-items-center ps-3 gap-8">

            <mat-chip-listbox *ngIf="showMatChip && (!currentSearch || currentSearch == currentResult)">
              <mat-chip-option (removed)="reset()" class="text-nowrap text_3">
                <span class="text-ellipsis">{{currentResult}}</span>
                <span class="material-icons-outlined font-16 text-black opacity-100" matChipRemove>close</span>
              </mat-chip-option>
            </mat-chip-listbox>


            <input (keyup)="doSearch($event)"
                   [(ngModel)]="currentSearch"
                   (blur)="showMatChip = false;"
                   (focusin)="showMatChip = false"
                   (focusout)="showMatChip = results"
                   [ngClass]="{'font-trueno-bold': currentSearch, 'input-text' : currentSearch, 'smaller': isMobile}"
                   class="appearance-none border-0 br-8 subtitle_1 py-3 bg-transparent flex-grow-1"
                   placeholder="{{ (showMatChip ? '' : 'PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.SEARCH_ROUTE_PLACEHOLDER') | translate }}"
                   type="text">
            <i class="fa fa-search d-flex align-items-center justify-content-center font-20 text-white bg-primary h-100"></i>
          </div>

          <div *ngIf="results && open" class="result position-absolute border border-primary">
            <div (click)="getPlaceInformations(addr.mapbox_id, addr.name)" *ngFor="let addr of results.suggestions; let first = first" [ngClass]="{'first-res': first}" class="res">
              <div [innerHtml]="colorResult(addr.name)" class="name d-inline-block"></div>
              ,
              <div [innerHtml]="colorResult(addr.place_formatted)" class="place d-inline-block"></div>
            </div>
            <span *ngIf="results.length == 0"
              class="m-2">{{ 'PROCESSES.ACCOMMODATION.SEARCH_ZONE_NO_RESULTS' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row w-100">
      <div class="col-4 d-flex align-items-center">
          <lf-icon class="me-2" fillColor="#1C69FF" height="24px" name="walk" width="24px"></lf-icon>
        <div class="duration text_3 pt-1" *ngIf="this.destinationCoordonates && currentResult; else elseWalkingBlock">
          <div class="d-flex" *ngIf="walking">
            <span class="me-1" *ngIf="getHours(walking.duration) > 0"> {{getHours(walking.duration)}}{{ ('PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.HOURS' + (isMobile ? '_MOBILE' : '')) | translate }} </span>
            <span>
                {{getMinutes(walking.duration)}}{{ ('PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.MINUTES' + (isMobile ? '_MOBILE' : '')) | translate }}
              </span>
          </div>

          <div class="distance text-nowrap" *ngIf="walking">
            {{getDistance(walking.distance)}} km
          </div>
        </div>
        <ng-template #elseWalkingBlock>
          <div class="duration text_3 pt-1">
            <span>{{ 'PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.WALKING' | translate }}</span>
          </div>
        </ng-template>
      </div>

      <div class="col-4 d-flex align-items-center">
        <lf-icon class="me-2" fillColor="#1C69FF" height="24px" name="bike" width="24px"></lf-icon>
        <div class="duration text_3 pt-1" *ngIf="this.destinationCoordonates && currentResult; else elseCyclingBlock">
          <div class="d-flex" *ngIf="cycling">
            <span class="me-1" *ngIf="getHours(cycling.duration) > 0">
            {{getHours(cycling.duration)}}{{ ('PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.HOURS' + (isMobile ? '_MOBILE' : '')) | translate }}
          </span>
            <span>
            {{getMinutes(cycling.duration)}}{{ ('PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.MINUTES' + (isMobile ? '_MOBILE' : '')) | translate }}
          </span>
          </div>

          <div class="distance text-nowrap" *ngIf="cycling">
            {{getDistance(cycling.distance)}} km
          </div>
        </div>
        <ng-template #elseCyclingBlock>
          <div class="duration text_3 pt-1">
            <span>{{ 'PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.CYCLING' | translate }}</span>
          </div>
        </ng-template>
      </div>

      <div class="col-4 d-flex align-items-center">
          <lf-icon class="me-2" fillColor="#1C69FF" height="24px" name="Car" width="24px"></lf-icon>
        <div class="duration text_3 pt-1" *ngIf="this.destinationCoordonates && currentResult; else elseDrivingBlock">
          <div class="d-flex" *ngIf="driving">
               <span class="me-1" *ngIf="getHours(driving.duration) > 0">
              {{getHours(driving.duration)}}{{ ('PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.HOURS' + (isMobile ? '_MOBILE' : '')) | translate }}
            </span>
            <span>
              {{getMinutes(driving.duration)}}{{ ('PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.MINUTES' + (isMobile ? '_MOBILE' : '')) | translate }}
            </span>
          </div>

          <div class="distance text-nowrap" *ngIf="driving">
            {{getDistance(driving.distance)}} km
          </div>
        </div>
        <ng-template #elseDrivingBlock>
          <div class="duration text_3 pt-1">
            <span>{{ 'PROCESSES.ACCOMMODATION.LIST.MAP_PROPERTY.DRIVING' | translate }}</span>
          </div>
        </ng-template>
      </div>

    </div>
  </div>
</div>
